import { ref, inject } from "vue";
import axios from "axios";
import { useStore } from "vuex";

export default function dropdownapi() {
  let energy = ref([]);
  const store = useStore();
  const http = ref(inject("http"));
  async function dropApiCall(event) {
    const apiget = axios.get;
    switch (event) {
      case 1:
        try {
          const response = await apiget(`${http.value.cscanErateType}`);
          if (response.data) {
            const payload = {
              value: response.data.data,
              id: 1,
            };
            console.log("DropDownSetValues...", payload);
            store.dispatch("Sector/setDropDownSetValues", payload);
          }
        } catch (error) {
          console.log(error);
          throw error;
        }
        break;
      case 2:
        try {
          const response = await apiget(`${http.value.cscanDmaCode}`);
          const senResp = [];
          if (response.data) {
            // console.log(response, "dmaresp");
            response.data.data.forEach((e) => {
              senResp.push({
                code: e.code,
                description: e.code + "-" + e.description,
              });
            });
            const payload = {
              value: senResp,
              id: 2,
            };
            store.dispatch("Sector/setDropDownSetValues", payload);
          }
        } catch (error) {
          console.error(error);
          throw error;
        }

        break;
      case 3:
        await apiget(`${http.value.cscanEdc}`)
          .then(function (response) {
            const senResp = [];
            if (response.data) {
              response.data.data.forEach((e) => {
                if (e.edc_panelists === 1) {
                  senResp.push({
                    edc_id: e.edc_id,
                    edc_name: e.edc_name,
                  });
                }
              });
              const payload = {
                value: senResp,
                id: 3,
              };
              store.dispatch("Sector/setDropDownSetValues", payload);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        break;
      case 4:
        await apiget(`${http.value.IncomeProducing}`)
          .then(function (response) {
            //console.log(response, " income");
            if (response.data) {
              const payload = {
                value: response.data.data,
                id: 4,
              };
              store.dispatch("Sector/setDropDownSetValues", payload);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        break;
      case 5:
        await apiget(`${http.value.ScoreHousehold}`)
          .then(function (response) {
            const senResp = [];
            if (response.data) {
              response.data.data.forEach((e) => {
                senResp.push({
                  code: e.code,
                  description: e.code + "(" + e.VSfH_average + ")",
                });
              });
              const payload = {
                value: senResp,
                id: 5,
              };
              store.dispatch("Sector/setDropDownSetValues", payload);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        break;
      case 6:
        await apiget(`${http.value.EtermLength}`)
          .then(function (response) {
            // console.log(response.data, " res eterm");
            if (response.data) {
              const payload = {
                value: response.data.data,
                id: 6,
              };
              store.dispatch("Sector/setDropDownSetValues", payload);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
        break;
      case 7:
        await apiget(`${http.value.master}master/v1/all-sectors?type=sector`)
          .then(function (response) {
            store.dispatch("Sector/setAllCategory", response);
          })
          .catch(function (error) {
            console.log(error);
          });
        break;
    }
  }

  return {
    energy,
    dropApiCall,
  };
}
